// Generated from the traced personal emblem (session scratchpad
// build-emblem.mjs; source artwork supplied by the user). ViewBoxes are
// 100 wide with the horizontal-spike axis exactly at the vertical center,
// so flex centering aligns it with adjacent text.
export const EMBLEM_VIEWBOX_H = 151.2;

/** Full emblem star pieces (spikes with eye cuts). */
export const EMBLEM_STAR: string[] = [
  "M50 0.1 L52.4 3.6 L59 59.7 L50 78.4 L40.9 60.1 L47.5 3.8 L49.9 0.1Z",
  "M32.4 69.5 L32.9 69.5 L49.4 79.6 L33.1 87.8 L22.7 84.3 L31.7 78.2 L25 70.2 L32.3 69.5Z",
  "M67.1 69.5 L75 70.2 L68.3 78.2 L77.3 84.3 L66.9 87.8 L50.6 79.6 L67 69.5Z",
  "M22.4 70.9 L28.9 77.8 L21 83.6 L4.4 78.7 L0 75.6 L4.3 73 L22.4 70.9Z",
  "M77.4 70.9 L95.6 73 L99.9 75.6 L95.7 78.7 L79 83.6 L71.1 77.8 L77.4 70.9Z",
  "M50 80.6 L59.1 96 L50 118.5 L40.8 96 L49.9 80.7Z",
];

/** The 8 ring blocks. */
export const EMBLEM_ARCS: string[] = [
  "M40.7 31.1 L37.8 58.8 L21.2 46 L21.6 40.4 L21.8 39.8 L25.5 37.2 L30.6 34.4 L36.5 32.2 L40.7 31.1Z",
  "M59.2 31.1 L64.6 32.5 L69.1 34.3 L73.4 36.6 L78.1 39.8 L78.4 40.1 L78.8 46 L62.2 58.8 L59.1 31.1Z",
  "M14 47.7 L20.2 47.7 L29.9 65.5 L4.7 69.1 L6 63.2 L7.9 57.9 L10.5 52.8 L13.9 47.8Z",
  "M79.8 47.7 L86 47.7 L87.4 49.5 L90.1 53.9 L92.5 58.8 L94.2 64 L95.2 69.1 L70 65.5 L79.7 47.8Z",
  "M4.7 82.7 L30.6 90.9 L22.6 106.7 L16.3 106.8 L12.3 101.9 L8.9 96.1 L6.4 89.8 L4.7 82.7Z",
  "M95.1 82.7 L93.9 88.9 L91.4 95.4 L87.7 101.8 L83.6 106.8 L77.4 106.8 L69.3 90.9 L95 82.7Z",
  "M37.8 99.4 L47 121.5 L41.3 120.8 L34.8 119 L29 116.5 L24.3 113.7 L23.5 108 L37.8 99.5Z",
  "M62 99.4 L76.5 108 L75.6 113.7 L72.9 115.4 L67.7 118.1 L62.7 119.8 L57.7 121 L53 121.5 L62 99.5Z",
];

/** Ring blocks in the emblem's reference colors. */
export const EMBLEM_ARCS_COLORED: { d: string; color: string }[] = [
  { d: "M40.7 31.1 L37.8 58.8 L21.2 46 L21.6 40.4 L21.8 39.8 L25.5 37.2 L30.6 34.4 L36.5 32.2 L40.7 31.1Z", color: "#ff3748" },
  { d: "M59.2 31.1 L64.6 32.5 L69.1 34.3 L73.4 36.6 L78.1 39.8 L78.4 40.1 L78.8 46 L62.2 58.8 L59.1 31.1Z", color: "#ff3748" },
  { d: "M14 47.7 L20.2 47.7 L29.9 65.5 L4.7 69.1 L6 63.2 L7.9 57.9 L10.5 52.8 L13.9 47.8Z", color: "#af5fbd" },
  { d: "M79.8 47.7 L86 47.7 L87.4 49.5 L90.1 53.9 L92.5 58.8 L94.2 64 L95.2 69.1 L70 65.5 L79.7 47.8Z", color: "#af5fbd" },
  { d: "M4.7 82.7 L30.6 90.9 L22.6 106.7 L16.3 106.8 L12.3 101.9 L8.9 96.1 L6.4 89.8 L4.7 82.7Z", color: "#ffe419" },
  { d: "M95.1 82.7 L93.9 88.9 L91.4 95.4 L87.7 101.8 L83.6 106.8 L77.4 106.8 L69.3 90.9 L95 82.7Z", color: "#ffe419" },
  { d: "M37.8 99.4 L47 121.5 L41.3 120.8 L34.8 119 L29 116.5 L24.3 113.7 L23.5 108 L37.8 99.5Z", color: "#58db8e" },
  { d: "M62 99.4 L76.5 108 L75.6 113.7 L72.9 115.4 L67.7 118.1 L62.7 119.8 L57.7 121 L53 121.5 L62 99.5Z", color: "#58db8e" },
];
export const EMBLEM_STAR_GOLD = '#ffcd06';

/** No-blocks star, eye cuts kept + diagonal rhombus spikes. */
export const STAR_NO_BLOCKS: string[] = [
  "M50 0.1 L52.4 3.6 L59 59.7 L50 78.4 L40.9 60.1 L47.5 3.8 L49.9 0.1Z",
  "M32.4 69.5 L32.9 69.5 L49.4 79.6 L33.1 87.8 L22.7 84.3 L31.7 78.2 L25 70.2 L32.3 69.5Z",
  "M67.1 69.5 L75 70.2 L68.3 78.2 L77.3 84.3 L66.9 87.8 L50.6 79.6 L67 69.5Z",
  "M22.4 70.9 L28.9 77.8 L21 83.6 L4.4 78.7 L0 75.6 L4.3 73 L22.4 70.9Z",
  "M77.4 70.9 L95.6 73 L99.9 75.6 L95.7 78.7 L79 83.6 L71.1 77.8 L77.4 70.9Z",
  "M50 80.6 L59.1 96 L50 118.5 L40.8 96 L49.9 80.7Z",
  "M50.8 78.5 L66 66.4 L77 49.7 L61.5 62.3Z",
  "M49.2 78.5 L34 66.4 L22.9 49.7 L38.5 62.3Z",
  "M50.9 80.2 L61 94.2 L78.9 107.2 L65.2 89.8Z",
  "M49.1 80.2 L38.9 94.2 L21.1 107.2 L34.7 89.8Z",
];

/** No-blocks star with each horizontal spike as one whole piece. */
export const STAR_NO_BLOCKS_SOLID: string[] = [
  "M50 0.1 L52.4 3.6 L59 59.7 L50 78.4 L40.9 60.1 L47.5 3.8 L49.9 0.1Z",
  "M50 80.6 L59.1 96 L50 118.5 L40.8 96 L49.9 80.7Z",
  "M0 75.6 L4.3 73 L25 70.2 L32.4 69.5 L32.9 69.5 L49.4 79.6 L33.1 87.8 L4.4 78.7Z",
  "M50.6 79.6 L67.1 69.5 L75 70.2 L95.6 73 L99.9 75.6 L95.7 78.7 L66.9 87.8Z",
  "M50.8 78.5 L66 66.4 L77 49.7 L61.5 62.3Z",
  "M49.2 78.5 L34 66.4 L22.9 49.7 L38.5 62.3Z",
  "M50.9 80.2 L61 94.2 L78.9 107.2 L65.2 89.8Z",
  "M49.1 80.2 L38.9 94.2 L21.1 107.2 L34.7 89.8Z",
];

/** v6: no-blocks star with a shorter top spike (still the longest spike).
    Own, tighter viewBox height. */
export const SHORT_TOP_VIEWBOX_H = 115.5;
export const STAR_SHORT_TOP: string[] = [
  "M50 0 L52.4 2.5 L59 41.9 L50 60.6 L40.9 42.2 L47.5 2.6 L49.9 0Z",
  "M32.4 51.6 L32.9 51.6 L49.4 61.8 L33.1 69.9 L22.7 66.4 L31.7 60.4 L25 52.4 L32.3 51.7Z",
  "M67.1 51.6 L75 52.4 L68.3 60.4 L77.3 66.4 L66.9 69.9 L50.6 61.8 L67 51.7Z",
  "M22.4 53 L28.9 60 L21 65.8 L4.4 60.9 L0 57.7 L4.3 55.2 L22.4 53.1Z",
  "M77.4 53 L95.6 55.2 L99.9 57.8 L95.7 60.8 L79 65.8 L71.1 59.9 L77.4 53.1Z",
  "M50 62.8 L59.1 78.1 L50 100.7 L40.8 78.2 L49.9 62.8Z",
  "M50.8 60.6 L66 48.5 L77 31.9 L61.5 44.4Z",
  "M49.2 60.6 L34 48.5 L22.9 31.9 L38.5 44.4Z",
  "M50.9 62.4 L61 76.3 L78.9 89.3 L65.2 72Z",
  "M49.1 62.4 L38.9 76.3 L21.1 89.3 L34.7 72Z",
];
